import { render, staticRenderFns } from "./micro.vue?vue&type=template&id=6af4000f"
import script from "./micro.vue?vue&type=script&lang=js"
export * from "./micro.vue?vue&type=script&lang=js"
import style0 from "./micro.vue?vue&type=style&index=0&id=6af4000f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports